import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  DropdownMenu,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import React, { useContext, useState, Fragment } from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { fetchDebtsToPay } from "../../helpers/api/finance";
import { isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Filter from "../common/Filter";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";
import ButtonIcon from "../common/ButtonIcon";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import VoidPaymentModal from "./VoidPaymentModal";

const ToPay = ({ setRedirectUrl, setRedirect, showPagination = true }) => {
  const moduleBase = useModuleBase();
  const { id } = useParams();
  const history = useHistory();
  const { selectedCondominium, condominium } = useSelector(
    (state) => state.condominium
  );
  const { role } = useSelector((state) => state.auth.user);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);

  const [params, setParams] = useState({
    state: 0,
    condominiumId: id,
    start_date: null,
    end_date: null,
  });

  const filter_options = [
    { value: 0, displayName: "No pagadas", disabled: false },
    { value: 1, displayName: "Pagadas", disabled: false },
    { value: 2, displayName: "Anuladas", disabled: false },
  ];

  const [voidTarget, setVoidTarget] = useState(null);

  const {
    data,
    isLoading,
    meta,
    mutate,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchDebtsToPay, params);

  const changeFilter = (update) => {
    setParams(update);
    goToPage(1);
  };

  return (
    <Fragment>
      <VoidPaymentModal
        isOpen={voidTarget !== null}
        toggle={() => setVoidTarget(null)}
        kind="debt"
        paymentId={voidTarget}
        onVoided={() => mutate()}
      />
      <PageHeader
        title={
          role === "manager"
            ? "Cuentas por pagar"
            : `Cuentas por pagar de ${condominium}`
        }
        titleTag="h2"
        description={
          role === "manager"
            ? "Gestiona y administra cada una de tus finanzas."
            : "Visualiza las finanzas de tu condominio."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>

      <Fragment>
        <Card>
          <FalconCardHeader title="Cuentas por pagar">
            <Row className="justify-content-end">
              <Col xs={12} className="d-flex mb-2 mb-md-0">
                <Filter
                  keyField="state"
                  options={filter_options}
                  selectType={changeFilter}
                  dateFilter={true}
                />
              </Col>
            </Row>
            {role === "manager" && (
              <Row className="mt-3 justify-content-end">
                <Col
                  xs={12}
                  md={"auto"}
                  className="mt-3 mt-md-0 text-center text-md-right mr-3"
                >
                  <ButtonIcon
                    onClick={() => {
                      setRedirectUrl(
                        `/dashboard/${moduleBase}/${selectedCondominium}/topay/create`
                      );
                      setRedirect(true);
                    }}
                    icon={"plus"}
                    color={"falcon-default"}
                  >
                    Añadir cuenta por pagar{" "}
                  </ButtonIcon>
                </Col>
              </Row>
            )}
          </FalconCardHeader>
          <CardBody className="fs--1 p-0">
            <PreloadState
              cond={data && isIterableArray(data)}
              loading={isLoading}
            >
              {data.length > 0 ? (
                <>
                  {data.map((cost, index) => (
                    <Fragment key={index}>
                      <Col className=" shadow-none border-top">
                        <Row className="mb-3 mt-3">
                          <Col className="d-flex align-items-center">
                            <div className="media-body">
                              <h6 className="mb-0 font-weight-semi-bold">
                                <span className="text-900">
                                  <p className="m-0">{cost?.name ? cost?.name : cost?.finance?.name}</p>
                                </span>
                              </h6>
                              <p className="m-0">{cost?.finance?.type?.name}</p>
                              <p className="m-0">
                                creada el{" "}
                                {moment(cost.created_at).format("DD-MM-YYYY")}
                              </p>
                              {cost.voided_at && (
                                <>
                                  <Badge className="rounded-capsule badge-soft-danger mt-1">
                                    Anulada
                                  </Badge>
                                  <p className="fs--2 mb-0 text-600">
                                    {`Anulada el ${moment(cost.voided_at).format("DD-MM-YYYY")}${cost.voided_by_name ? ` por ${cost.voided_by_name}` : ""}`}
                                  </p>
                                  {cost.void_reason && (
                                    <p className="fs--2 mb-0 text-600">
                                      Motivo: {cost.void_reason}
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                          <Col className="d-flex justify-content-center flex-column align-items-end">
                            <Row>
                              <Col xs={12}>
                                <p className="text-right mb-0">
                                  Monto cancelado
                                </p>
                              </Col>
                              <Col xs={12}>
                                <h6 className="text-right text-primary">
                                  <NumberFormat
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    displayType="text"
                                    value={cost.total_paid}
                                  />
                                </h6>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <p className="text-right mb-0">Monto total</p>
                              </Col>
                              <Col xs={12}>
                                <h6 className="text-right">
                                  <NumberFormat
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    displayType="text"
                                    value={cost.amount}
                                  />
                                  {/* La tasa de la fecha del gasto, la misma
                                      que muestra el detalle: la de hoy daria
                                      dos cifras distintas para la misma
                                      cuenta. */}
                                  {cost.exchange_rate && (
                                    <NumberFormat
                                      className="text-right"
                                      displayType="text"
                                      allowedDecimalSeparators={true}
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      prefix={
                                        " | " +
                                        (cost.exchange_rate.currency?.iso ||
                                          curr?.currency?.iso) +
                                        " "
                                      }
                                      value={cost.amount_converted}
                                    />
                                  )}
                                </h6>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            xs="auto"
                            className="d-sm-flex align-items-center"
                          >
                            <UncontrolledDropdown
                              direction="left"
                              className="d-inline-block ml-2"
                            >
                              <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem
                                  /*     onClick={() => handleEdit(cost.id)} */
                                  onClick={() =>
                                    history.push({
                                      pathname: `/dashboard/${moduleBase}/${id}/topay-provider/edit/${cost.id}`,
                                    })
                                  }
                                >
                                  Ver detalles
                                </DropdownItem>
                                {role === "manager" && cost.can_void && (
                                  <DropdownItem
                                    className="text-danger"
                                    onClick={() => setVoidTarget(cost.id)}
                                  >
                                    Anular cuenta
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </Col>
                        </Row>
                      </Col>
                    </Fragment>
                  ))}
                </>
              ) : (
                <Row className="p-card">
                  <Col>
                    <Alert color="info" className="mb-0">
                      Al parecer aún no hay cuentas para mostrar.
                    </Alert>
                  </Col>
                </Row>
              )}
              {showPagination && (
                <FullPagination
                  nextPage={nextPage}
                  prevPage={previousPage}
                  goToPage={goToPage}
                  meta={meta}
                  className={"shadow-none"}
                  posText={"Cuentas por pagar"}
                  perPage={perPage}
                />
              )}
            </PreloadState>
          </CardBody>
        </Card>
      </Fragment>
    </Fragment>
  );
};

ToPay.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(ToPay);
